import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListUserApiKeys from "../../../../components/@userApiKeys/userApiKeys/ListUserApiKeys";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function UserApiKeysPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListUserApiKeys
                routeType={routeType}
            />
        </SettingFrame>
    )
}       